import { createContext, type Dispatch, type SetStateAction, useContext } from 'react';

type SupportModalState = [boolean, Dispatch<SetStateAction<boolean>>];

export const SupportModalContext = createContext<SupportModalState | undefined>(undefined);

const useSupportModal = (): SupportModalState => {
  const supportModalState = useContext(SupportModalContext);
  if (supportModalState === undefined) {
    throw new Error('Cannot call useSupportModal() without being inside a SupportModalContext.');
  }
  return supportModalState;
};

export default useSupportModal;
